import $ from "jquery";
import {active} from "./const.js";

$(window).scroll(function() {
  $('#js-topFixed').css("left", -$(window).scrollLeft());
});

// 固定ヘッダーの高さ分ずらす
$(window).on('load', function() {
  const url = $(location).attr('href'),
        headerHeight = $('#js-topFixed').outerHeight();

  if(url.indexOf("#") != -1){
    const anchor = url.split("#"),
          target = $('#' + anchor[anchor.length - 1]),
          position = Math.floor(target.offset().top) - headerHeight;
		$("html, body").animate({scrollTop:position}, 10);
  }
});

const topFixed = document.getElementById('js-topFixed');
const main = document.querySelector('.l-main');
const localNavs = document.querySelectorAll('.js-globalLocalNav');
const navLogo = document.getElementById('js-globalNavLogo');

let isFixed = false;
let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  const isScrollingUp = scrollY < lastScrollY;

  if (scrollY > 300 && !isFixed) {
    isFixed = true;
    topFixed.classList.add(active);
    main.classList.add(active);
    localNavs.forEach(nav => nav.classList.add('-compact'));
    navLogo.classList.add(active);
    topFixed.style.top = '-100%';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        topFixed.style.top = '-90px';
      });
    });
  }

  if (isScrollingUp && isFixed) {
    topFixed.style.top = '0';
    localNavs.forEach(nav => nav.classList.remove('-compact'));
    navLogo.classList.remove(active);
  } else if (scrollY > 300) {
    // ← 下方向で300pxより下にいるときだけ
    topFixed.style.top = '-90px';
    localNavs.forEach(nav => nav.classList.add('-compact'));
    navLogo.classList.add(active);
  }

  if (!isScrollingUp && scrollY <= 300 && isFixed) {
    topFixed.style.top = '-100%';

    topFixed.addEventListener('transitionend', function handleTransition() {
      topFixed.classList.remove(active);
      main.classList.remove(active);
      localNavs.forEach(nav => nav.classList.remove('-compact'));
      navLogo.classList.remove(active);
      topFixed.style.top = '';
      topFixed.removeEventListener('transitionend', handleTransition);
      isFixed = false;
    });
  }

  lastScrollY = scrollY;
});
